import React, { Component } from 'react';
import { Select2 } from "select2-react-component";
//import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilder/FormBuilderFunctions/FieldProps';
import Wrp from '../../../hoc/Wrp/Wrp';
import $ from 'jquery';


class PickList extends Component {
  render() {

    let filterObject = this.props.filterObject;

    const  {
      item,
      className,
      section,
      validationForms
    } = this.props;

    const updateData = {
      section_index:'',
      itemIndex:'',
      item:item,
    }
    const attr = formFieldsAttributes(
      {...item,className:className, id: "replaceColumnInput"
    },validationForms,value => this.props.onChangeFormInput(updateData,value,'PickList'));
    // if(item.overridden===false && attr.value!==''){
    //     this.onChangePickList(updateData,attr.value,'PickList')
    // }

    
    let select2Options = [];
    //console.log(JSON.stringify(this.props.options + 'props.options'))
    select2Options = this.props.options.map((item,index)=>{
      return(
        {
          label:item.label,
          value:item.value,
        }
      )
    });

    
   
    return (
      <Wrp>
        <Select2 data={select2Options}
            {...attr.fieldAttributes}
            minCountForSearch ={1}
            //value={this.props.value[0]}
            //update={value => props.onChangePickList(updateData,value,'PickList')}
            update={e => this.props.handleChange(e,this.props.attr1)}
            //multiple={true}
            >
        </Select2>
        <input type="hidden" id={"replaceColumnInput"} />
      </Wrp>
    );
  }
  onChangePickList = (updateData,value,fieldType)=>{
    //let fieldDetail = JSON.parse(this.props.fieldDetails);
    //$("#replaceColumnInput"+fieldDetail.colIndex).val(value)    
  }
}

PickList.defaultProps = {
  disabled: false,
  generator: false,
  className: 'form-control'
}

export default PickList;